import React from 'react'
import AboutContent from '../Components/About/About'

function About() {
  return (
    <div>
        <AboutContent/>
    </div>
  )
}

export default About